'use strict';

require('./Content.less');
